import styles from "./index.module.scss";
import ApplestoreImg from "../../assets/images/share/appstore.png";

const AppleButton = () => (
  <img
    onClick={() =>
      window.open(
        "https://apps.apple.com/au/app/spark-relief-teachers/id1607855193"
      )
    }
    src={ApplestoreImg}
    alt='ApplestoreImg'
    className={styles.ApplestoreImg}
  />
);

export default AppleButton;
